import React, { useState, useEffect } from "react";
//import { Button, Form, Alert } from "react-bootstrap";
import {connect, useSelector} from 'react-redux';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Spinner from 'react-bootstrap/Spinner';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import * as actions from '../store/actions/index';
import * as actionTypes from '../store/actions/actionTypes';
import {makeStyles} from "@material-ui/core/styles/index";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    header: {
        textAlign: 'center',
        spacing: 10,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,

    },
    input: {
        borderRadius: 4,
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 5px 10px 5px',
        margin: theme.spacing(1),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

function RetrieveCredits(props) {

    const [credits, setCredits] = useState(0);

    const classes = useStyles();

    useEffect(()=>{
        //props.onGetClientTransactions(props.token, props.currentClientName);
        props.onInitializeRetrieveCredits();
    },[]);

    useEffect(() => {
        if (props.isFailRetrieveCredits){
            console.log('logging isfailretrieve credits', props.isFailRetrieveCredits);
            var errorMessage = '' + props.isFailRetrieveCredits;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isFailRetrieveCredits]);

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    function validateForm() {
        return credits != 0;
    }

    function handleSubmit(event) {
        event.preventDefault();
        //console.log("login", client.name);
        //console.log("password", client.password);
        //console.log("macaddress", client.mac);
        //console.log("months", months);
        //console.log("description", client.description);
        //console.log("phone", client.phone);
        const data = {
            login: props.currentClientName,
            credits: credits

        };
        console.log('logging data', data);
        if (props.role === "admin") {
            console.log('props admin', props.admin);
            console.log('props login', props.client);
            props.onRetrieveCreditsAdmin(props.token, {login: props.client, credits: credits});
        } else if (props.role === "manager") {
            props.onRetrieveCreditsSuperReseller(props.token, {login: props.client, credits: credits});
        } else if (props.role === "reseller"){
            props.onRetrieveCreditsReseller(props.token, {login: props.client, credits: credits});
        } else {
            props.onRetrieveCredits(props.token, data);
        }
    }

    if(props.isSuccessRetrieveCredits){
        console.log('redirecting because', props.isSuccessRetrieveCredits);

        if (props.role === "admin") {
            props.onGetClientAdmin(props.token, props.client);
            props.onGetClientTransactionsAdmin(props.token, props.client);
        } else if (props.role === "manager") {
            props.onGetClientSuperReseller(props.token, props.client);
            props.onGetClientTransactionsSuperReseller(props.token, props.client);
        } else if (props.role === "reseller") {
            props.onGetClientReseller(props.token, props.client);
            props.onGetClientTransactionsReseller(props.token, props.client);
        } else {
            props.onGetClient(props.token, props.currentClientName);
            props.onGetClientTransactions(props.token, props.currentClientName);
            props.onGetCredits(props.token);
        }

        props.onInitializeRetrieveCredits();
        var successMessage = 'Retrieved ' + credits + ' credit(s)';
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
    }

    return (
        <Card>
            <CardHeader
                title="Retrieve Credits"
                titleTypographyProps={{
                    fontSize: 17,
                    fontWeight: 'bold'
                }}
                subheaderTypographyProps={{
                    fontSize: 14,
                }}
            />
            <Divider variant="middle" />
            <CardContent>
                <form>
                    <FormGroup row>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel id="select-credits-label">Credits</InputLabel>
                            <Select
                                id="credits"
                                labelId="Select credits"
                                onChange={e => setCredits(e.target.value)}
                            >
                                <MenuItem value={0}>Select Credits</MenuItem>
                                <MenuItem value={1}>1 Month</MenuItem>
                                <MenuItem value={2}>2 Months</MenuItem>
                                <MenuItem value={3}>3 Months</MenuItem>
                                <MenuItem value={4}>4 Months</MenuItem>
                                <MenuItem value={5}>5 Months</MenuItem>
                                <MenuItem value={6}>6 Months</MenuItem>
                                <MenuItem value={7}>7 Months</MenuItem>
                                <MenuItem value={8}>8 Months</MenuItem>
                                <MenuItem value={9}>9 Months</MenuItem>
                                <MenuItem value={10}>10 Months</MenuItem>
                                <MenuItem value={11}>11 Months</MenuItem>
                                <MenuItem value={12}>12 Months</MenuItem>
                            </Select>
                        </FormControl>
                    </FormGroup>
                </form>
            </CardContent>
            <CardActions>
                <Button
                    block
                    disabled={!validateForm() || props.isLoadingRetrieveCredits}
                    type="submit"
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    size="small"
                    fullWidth
                >
                    {props.isLoadingSaveClient
                        ? spinner
                        : 'Retrieve'}
                </Button>
            </CardActions>
        </Card>

    );
}

const mapDispatchToProps = dispatch => {
    return {
        onRetrieveCredits: (token, data) => dispatch(actions.retrieveCredits(token, data)),
        onRetrieveCreditsAdmin: (token, data) => dispatch(actions.retrieveCreditsAdmin(token, data)),
        onRetrieveCreditsSuperReseller: (token, data) => dispatch(actions.retrieveCreditsSuperReseller(token, data)),
        onRetrieveCreditsReseller: (token, data) => dispatch(actions.retrieveCreditsReseller(token, data)),
        onInitializeRetrieveCredits: () => dispatch(actions.initializeRetrieveCredits()),
        onGetClient: (token, name) => dispatch(actions.getClient(token, name)),
        onGetClientAdmin: (token, name) => dispatch(actions.getClientAdmin(token, name)),
        onGetClientSuperReseller: (token, name) => dispatch(actions.getClientSuperReseller(token, name)),
        onGetClientReseller: (token, name) => dispatch(actions.getClientReseller(token, name)),
        onGetCredits: (token) => dispatch(actions.creditsUser(token)),
        onGetClientTransactions: (token, login) => dispatch(actions.getTransactionsClient(token, login)),
        onGetClientTransactionsAdmin: (token, login) => dispatch(actions.getTransactionsAdminClient(token, login)),
        onGetClientTransactionsSuperReseller: (token, login) => dispatch(actions.getTransactionsSuperResellerClient(token, login)),
        onGetClientTransactionsReseller: (token, login) => dispatch(actions.getTransactionsResellerClient(token, login)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))

    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        currentClientName: state.clientReducer.name,
        isSuccessRetrieveCredits: state.retrieveCredits.credits,
        isLoadingRetrieveCredits: state.retrieveCredits.loading,
        isFailRetrieveCredits: state.retrieveCredits.error
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RetrieveCredits);